import { render, staticRenderFns } from "./LivingExpensesSection.vue?vue&type=template&id=2ce5db54&scoped=true&"
import script from "./LivingExpensesSection.vue?vue&type=script&lang=js&"
export * from "./LivingExpensesSection.vue?vue&type=script&lang=js&"
import style0 from "./LivingExpensesSection.vue?vue&type=style&index=0&id=2ce5db54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5db54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VCombobox,VIcon,VSelect,VSimpleTable,VTextField})
